import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Image from "next/image";

const UspFaq = () => {
  return (
    <>
      <div className="mx-auto bg-white w-full xl:px-0 md:px-6 lg:!px-6  px-5 relative square_grid_bg md:pt-[60px] pt-[24px] md:pb-20 pb-16">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative">
          <h2 className="font-semibold md:text-[36px] text-[24px] text-[#05192E] text-center md:mb-[40px] mb-[30px] leading-normal">
            <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
              FAQs
            </span>
          </h2>
          <Accordion type="single" collapsible className="w-full md:px-14">
            <AccordionItem
              value="item-1"
              className="bg-[#fff] leading-[1.5rem] text-[#253B80] rounded-[14px] relative z-10 mb-[18px] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)]"
            >
              <AccordionTrigger className="hover:no-underline font-semibold md:text-[22px] text-[16px] text-left md:leading-[32px] leading-5 md:pl-[30px] px-[20px] py-[18px] faq_shadow rounded-[14px]">
                THE WHYs
              </AccordionTrigger>
              <AccordionContent className="content font-normal md:text-[18px] text-[16px] md:leading-[30px] leading-[22px] text-[#030F1C]">
                <div className="px-[20px] py-[5px]">
                  <p className="md:text-[18px] text-[14px] font-normal leading-[1.4] text-[##030F1C]">
                    <span className="font-bold">
                      1. WHY should I work in the US?
                    </span>
                    <br />
                    <br />
                    The demand for accountants in the US, along with its vast
                    economy, creates an incredible opportunity for Indian
                    accountants. You could secure roles at top accounting firms
                    in major cities like New York, Chicago, LA, and San
                    Francisco, with starting salaries of $60,000+ (INR 50
                    lakhs+). It’s a fast track to launching a rewarding career
                    on a global scale.
                    <br />
                    <br />
                    <span className="font-bold">
                      {" "}
                      2. WHY is STEM important to get a job in the US?
                    </span>
                    <br />
                    <br />
                    STEM stands for Science, Technology, Engineering, and
                    Mathematics, but don’t let that intimidate you—it’s actually
                    your gateway to a 3-year work opportunity in the US! Miles
                    has teamed up with top US universities to add Business
                    Analytics to their Master’s in Accounting curriculum, making
                    it a STEM-certified program. This certification extends your
                    OPT (Optional Practical Training) to three years on an F-1
                    visa (just like techies!), instead of just one.
                    <br />
                    <br />
                    <span className="font-bold">
                      3. WHY should I consider working in the US over India?
                    </span>
                    <br />
                    <br />
                    With the rising shortage of accountants, top accounting
                    firms like RSM, BDO, Allinial Global, and many more are
                    looking to hire Indian accountants to work in their US
                    offices for 3 years, with starting salaries of $60,000+ (INR
                    50 lakhs+). While opportunities in India are also promising,
                    as a CPA in India, you can work at the Big 4 and 220+ MNCs
                    with an average salary of 10 lakhs. So, if you dream of
                    working in cities like New York, Chicago, LA, San Francisco,
                    and others across the US, the Miles US Pathway will help you
                    achieve that.
                    <br />
                    <br />
                    <span className="font-bold">
                      4. WHY is Master in Accounting important to get a job in
                      the US?
                    </span>
                    <br />
                    <br />
                    To work in the US, securing the right visa is essential.
                    While the CPA is a highly valuable qualification, it’s not a
                    university degree and doesn’t grant a visa. The only path to
                    a US F-1 student visa is through a Master’s program. That’s
                    why Miles has partnered with top US universities to offer a
                    STEM-certified Master’s in Accounting, providing a 3-year
                    OPT (Optional Practical Training) period on your F-1 visa.
                    This extended OPT lets you gain valuable work experience in
                    the US, while the Master’s program itself strengthens your
                    CPA skills and career foundation. In short, a Master’s is
                    essential—not only for securing your visa but also for
                    maximizing your career opportunities in the US
                    <br />
                    <br />
                    <span className="font-bold">
                      5. WHY is CPA important to get a job in the US?
                    </span>
                    <br />
                    <br />
                    A CPA (Certified Public Accountant) is a highly regarded
                    credential that is often required for accounting roles in
                    the US It opens doors to top accounting firms, and allows
                    you to work in areas like audit, tax, and advisory. With a
                    CPA, you’ll have a competitive edge, as US companies
                    specifically seek CPAs to meet their high standards for
                    reporting and compliance. Additionally, a CPA license can
                    lead to higher salaries—starting at $60,000+ (INR 50
                    lakhs+)—and provides greater job stability and career growth
                    in the US The CPA credential is your gateway to landing
                    prestigious roles and building a long-term career in the US
                    <br />
                    <br />
                    <span className="font-bold">
                      6. WHY 9 credits in India?
                    </span>
                    <br />
                    <br />
                    Miles has collaborated with JAGSoM, an AACSB-accredited
                    B-School in India, to offer a unique credit transfer system.
                    By earning 9 credits in India, you can reduce your US
                    university fees by 30% to 70% and shorten the time required
                    to complete your Master’s degree in the US This not only
                    lowers your overall cost of living in the US but also gives
                    you more time to focus on completing your CPA. Plus, you can
                    benefit from GMAT/GRE and IELTS/TOEFL waivers, making the
                    entire process smoother and more cost-effective.
                    <br />
                    <br />
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem
              value="item-2"
              className="bg-[#fff] leading-[1.5rem] text-[#253B80] rounded-[14px] relative z-10 mb-[18px] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)]"
            >
              <AccordionTrigger className="hover:no-underline font-semibold md:text-[22px] text-[16px] text-left md:leading-[32px] leading-5 md:pl-[30px] px-[20px] py-[18px] faq_shadow rounded-[14px]">
                THE WHATs
              </AccordionTrigger>
              <AccordionContent className="content font-normal md:text-[18px] text-[16px] md:leading-[30px] leading-[22px] text-[#030F1C]">
                <div className="px-[20px] py-[5px]">
                  <p className="md:text-[18px] text-[14px] font-normal leading-[1.4] text-[##030F1C]">
                    <span className="font-bold">
                      7. WHAT is the fees for the Miles US Pathway program?
                    </span>
                    <br />
                    <br />
                    The total cost of the Miles US Pathway program is
                    approximately $48,000. However, you only need around $2,000
                    upfront, with the rest covered by student loans. Here’s how
                    Miles helps reduce your costs:
                    <br /> 1. Credit Transfer: Thanks to our collaboration with
                    JAGSoM, an AACSB-accredited B-School in India, you complete
                    30% of your coursework in India. This reduces your US
                    university tuition by up to 50%, and in some cases, even
                    70%.
                    <br /> 8. Scholarships: Miles partners with US universities
                    to secure scholarships, leveraging both the high quality of
                    our talent pool and our cohort size (20+ students per
                    university). This approach makes the program far more
                    affordable while still offering a top-tier education and
                    extended work opportunities in the US
                    <br />
                    <br />
                    <span className="font-bold">
                      8. WHAT are the universities that are available?
                    </span>
                    <br />
                    <br />
                    Miles partners with over 30+ universities, including
                    top-ranked institutions like Michigan State University and
                    Rutgers University. We also offer location-specific options,
                    such as Pace University and Fordham University in New York,
                    DePaul University in Chicago, and Seattle University in
                    Seattle. While Miles supports job placements, your
                    university choice isn’t critical to your job prospects. For
                    more guidance, reach out to our US Pathway team—they’ll help
                    you choose the best university for your needs.
                    <br />
                    <br />
                    <span className="font-bold">
                      {" "}
                      9. WHAT are the jobs for Indian accountants in the US?
                    </span>
                    <br />
                    <br />
                    Indian accountants have a wide range of job opportunities in
                    the US, particularly in areas like audit, tax, and advisory.
                    Here are some of the key roles you can pursue:
                    <br /> 1. Audit and Assurance: Work with top firms like RSM,
                    BDO, and Allinial Global, helping clients ensure the
                    accuracy and compliance of their financial statements.
                    <br /> 2. Taxation: Specialize in US tax regulations,
                    working in tax planning, preparation, and consulting for
                    both individuals and businesses.
                    <br /> 3. Accounting: Handle the financial and management
                    accounting needs, focusing on GAAP compliance, budgeting,
                    and financial forecasting. With the shortage of accountants
                    in the US, companies are increasingly hiring Indian CPAs and
                    accountants for these roles, offering starting salaries of
                    $60,000+ (INR 50 lakhs+).
                    <br />
                    <br />
                    <span className="font-bold">
                      {" "}
                      10. WHAT is the salary for Indian accountants in the US?
                    </span>
                    <br />
                    <br />
                    Miles CPA alumni can earn starting salaries of $60,000+ (INR
                    50 lakhs+) in the US
                    <br />
                    <br />
                    <span className="font-bold">
                      {" "}
                      11. WHAT will happen after 3-years of work in the US?
                    </span>
                    <br />
                    <br />
                    After your 3 years in the US, you have a few options. You
                    can return to India and either continue working remotely
                    with the same firm or Miles will assist you in securing a
                    position at the Big 4 or one of 200+ MNCs in India.
                    Alternatively, if your US employer decides to sponsor your
                    H-1B visa, you can continue working in the US beyond the
                    3-year period. However, this sponsorship is entirely at the
                    discretion of your employer, and Miles has no influence over
                    this process. Additionally, even if you are nominated for an
                    H-1B visa, it is subject to the annual cap of 85,000 visas
                    and the lottery system.
                    <br />
                    <br />
                    <span className="font-bold">
                      {" "}
                      12. WHAT is the refund policy?
                    </span>
                    <br />
                    <br />
                    Although we boast over a 90%+ visa acceptance rate, if your
                    US visa faces rejection (twice), We assure you a full refund
                    of your 20K fee.
                    <br />
                    <br />
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem
              value="item-4"
              className="bg-[#fff] leading-[1.5rem] text-[#253B80] rounded-[14px] relative z-10 mb-[18px] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)]"
            >
              <AccordionTrigger className="hover:no-underline font-semibold md:text-[22px] text-[16px] text-left md:leading-[32px] leading-5 md:pl-[30px] px-[20px] py-[18px] faq_shadow rounded-[14px]">
                THE WHENs
              </AccordionTrigger>
              <AccordionContent className="content font-normal md:text-[18px] text-[16px] md:leading-[30px] leading-[22px] text-[#030F1C]">
                <div className="px-[20px] py-[5px]">
                  <p className="md:text-[18px] text-[14px] font-normal leading-[1.4] text-[##030F1C]">
                    <span className="font-bold">
                      13. WHEN are the admissions open?
                    </span>
                    <br />
                    <br />
                    Admissions for the Miles US Pathway program are open
                    year-round, allowing you to apply at any time. However, US
                    university intakes typically happen during the Fall
                    (August/September) and Spring (January) semesters. It’s best
                    to start your application process early to ensure you meet
                    the deadlines for your preferred intake. The Miles team will
                    guide you through the admissions process and help you choose
                    the best intake based on your timeline and preferences.
                    <br />
                    <br />
                    <span className="font-bold">
                      14. WHEN should I start and complete the program?
                    </span>
                    <br />
                    <br />
                    Ideally, you should start the Miles US Pathway program at
                    least 8-10 months before your preferred intake. Currently,
                    admissions are open for Fall 2025.Here’s an indicative
                    timeline of your US journey:
                    {/* add the design of the timeline */}
                    <Image
                      src="/usp/timeline.webp"
                      alt="Timeline"
                      className="md:block hidden mt-6"
                      width={1591}
                      height={426}
                      priority
                    />
                    <Image
                      src="/usp/coh.webp"
                      alt="Miles US Pathway Roadmap"
                      className="md:hidden block mx-auto w-full relative mt-4"
                      width={466}
                      height={610}
                      priority
                    />
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem
              value="item-3"
              className="bg-[#fff] leading-[1.5rem] text-[#253B80] rounded-[14px] relative z-10 mb-[18px] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)]"
            >
              <AccordionTrigger className="hover:no-underline font-semibold md:text-[22px] text-[16px] text-left md:leading-[32px] leading-5 md:pl-[30px] px-[20px] py-[18px] faq_shadow rounded-[14px]">
                THE WHOs
              </AccordionTrigger>
              <AccordionContent className="content font-normal md:text-[18px] text-[16px] md:leading-[30px] leading-[22px] text-[#030F1C]">
                <div className="px-[20px] py-[5px]">
                  <p className="md:text-[18px] text-[14px] font-normal leading-[1.4] text-[##030F1C]">
                    <span className="font-bold">
                      15. WHO is eligible for the Miles US Pathway program?
                    </span>
                    <br />
                    <br />
                    To be eligible for the Miles US Pathway program, you
                    generally need to have completed 4 years of university
                    education, equivalent to the US undergraduate requirement.
                    If you have a B.Com/BBA along with an M.Com/MBA or
                    professional qualifications like CA/CS/CWA, you're already
                    eligible. If you have only a B.Com/BBA from a NAAC A
                    university with a first division, you are eligible. If you
                    still do not meet the above criteria, don’t worry! Miles
                    offers a university bridge course for just INR 30K. The best
                    part? It’s fully integrated with the CPA coursework, so
                    there are no additional studies beyond your CPA preparation.
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem
              value="item-6"
              className="bg-[#fff] leading-[1.5rem] text-[#253B80] rounded-[14px] relative z-10 mb-[18px] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)]"
            >
              <AccordionTrigger className="hover:no-underline font-semibold md:text-[22px] text-[16px] text-left md:leading-[32px] leading-5 md:pl-[30px] px-[20px] py-[18px] faq_shadow rounded-[14px]">
                THE HOWs
              </AccordionTrigger>
              <AccordionContent className="content font-normal md:text-[18px] text-[16px] md:leading-[30px] leading-[22px] text-[#030F1C]">
                <div className="px-[20px] py-[5px]">
                  <p className="md:text-[18px] text-[14px] font-normal leading-[1.4] text-[##030F1C]">
                    <span className="font-bold">16. HOW do I get started?</span>
                    <br />
                    <br />
                    To get started with the Miles US Pathway program, follow
                    these simple steps:
                    <br /> 1. Visit the Miles Stadium of Learning: Click the
                    link below to schedule a visit at one of our 9 locations
                    across India, where you’ll receive personalized guidance and
                    support from the Miles team:
                    <br />
                    <a
                      href="  https://www.mileseducation.com/us-jobs-for-accountants?tk=9fcc2911-1add-4c19-8b8a-829285b908f9"
                      className="text-blue-600"
                    >
                      {" "}
                      https://www.mileseducation.com/us-jobs-for-accountants?tk=9fcc2911-1add-4c19-8b8a-829285b908f9
                    </a>
                    <br />
                    2. Connect with a Counselor: Our expert counselors will help
                    you understand the program, eligibility, university options,
                    and guide you through the application process.
                    <br /> 3. Start Your CPA Preparation: Once you’re enrolled,
                    you can begin your CPA preparation with Miles’ study
                    materials, which are fully integrated with the program.
                    <br /> 4. Prepare for Your US Journey: From visa assistance
                    to travel arrangements, Miles will support you every step of
                    the way to ensure a smooth transition to working in the US
                    <br />
                    <br />
                    <span className="font-bold">
                      17. HOW many Miles alumni are working in the US?
                    </span>
                    <br />
                    <br />
                    1000+ Miles alumni are already living their American Dream
                    with the Miles US Pathway:
                    <br />
                    <a href="/alumni" className="text-blue-600">
                      {" "}
                      https://www.mileseducation.com/alumni
                    </a>
                    <br />
                    <br />
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default UspFaq;
